import { Module } from 'cerebral'
import bootstrap from './chains/bootstrap'
import onLogoClicked from './chains/onLogoClicked'
import changeModule from './chains/changeModule'
import onDismiss from './chains/onDismiss'
import onConfirm from './chains/onConfirm'
import triggerSignal from './chains/triggerSignal'
import removeSnackbar from './chains/removeSnackbar'
import showError from './chains/showError'
import setDialogCheckvalue from './chains/setDialogCheckvalue'
import toggleDialogCheckvalue from './chains/toggleDialogCheckvalue'
import handleError from './chains/handleError'
import reload from './chains/reload'

export default Module(({ name, path, controller }) => {
  return {
    signals: {
      bootstrap,
      handleError,
      onLogoClicked,
      changeModule,
      onDismiss,
      onConfirm,
      removeSnackbar,
      triggerSignal,
      showError,
      setDialogCheckvalue,
      toggleDialogCheckvalue,
      reload
    },

    state: {
      currentView: 'startpage',
      showSort: false,
      snackbars: [],
      dialog: null,
      loading: true,
      hasAgreedOnTerms: false
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/App/index.js